import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';

@Injectable()
export class HttpUtilsService {

    /**
     * get standard content-type
     */
    getHTTPHeaders(token: string | null = null): HttpHeaders {
        const userToken = localStorage.getItem(environment.authTokenKey) || token;
        return new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: 'Bearer ' + userToken
        });
    }

    getHTTPHeadersWithoutContentType(token: string | null | undefined = null): HttpHeaders {
        const userToken = localStorage.getItem(environment.authTokenKey) || token;
        return new HttpHeaders({
            Authorization: 'Bearer ' + userToken
        });
    }

    /**
     * アップロードの進捗を出す場合などに、NGSWを通すと、進捗が取れなくなるので、
     * バイパスする必要がある。
     * 
     * distのngsw-woker.jsを見て、ヘッダーにngsw-bypassというフィールドがあればいいことが分かったが、
     * このngsw-woker.jsがどこで生成されているのかとかはよくわからない。
     * 
     * @see https://github.com/angular/angular/issues/32429
     * @see https://v17.angular.io/guide/service-worker-devops#bypassing-the-service-worker
     * @see https://github.com/w3c/ServiceWorker/issues/1141
     */
    getHTTPHeadresWithoutContentTypeWithByPassNgsw(token: string | null | undefined = null): HttpHeaders {
        const userToken = localStorage.getItem(environment.authTokenKey) || token;
        return new HttpHeaders({
            Authorization: 'Bearer ' + userToken,
            'ngsw-bypass': 'True',
        });
    }
}
